type Query = Record<string, string | number | boolean | null | undefined>

async function request<T>(path: string, method: "GET" | "POST" | "DELETE", payload?: Query | Record<string, unknown>): Promise<T> {
  let url = path
  const init: RequestInit = {
    method,
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  }
  if (method === "GET" && payload) {
    const params = new URLSearchParams()
    for (const [key, value] of Object.entries(payload)) {
      if (value !== undefined && value !== null) params.set(key, String(value))
    }
    const query = params.toString()
    if (query) url += `?${query}`
  } else if (method === "POST" || method === "DELETE") {
    init.headers = { ...init.headers, "Content-Type": "application/json" }
    init.body = JSON.stringify(payload || {})
  }

  const response = await fetch(url, init)
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data.error || `HTTP ${response.status}`)
  return data as T
}

export function getRoute<T>(path: string) {
  return {
    run(_ctx: unknown): Promise<T> {
      return request<T>(path, "GET")
    },
    query(query: Query) {
      return {
        run(_ctx: unknown): Promise<T> {
          return request<T>(path, "GET", query)
        },
      }
    },
  }
}

export function postRoute<T>(path: string) {
  return {
    run(_ctx: unknown, body?: Record<string, unknown>): Promise<T> {
      return request<T>(path, "POST", body)
    },
  }
}

export function deleteRoute<T>(path: string) {
  return {
    run(_ctx: unknown, body?: Record<string, unknown>): Promise<T> {
      return request<T>(path, "DELETE", body)
    },
  }
}
